import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useInboxTodos } from 'features/tasks';
import { useUpdateInboxTaskOrder } from 'features/user';
import React, { useMemo } from 'react';
import { SelfSortingTaskSection } from 'shared/components/ui/task-section';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useActiveTaskId } from 'shared/contexts/task-detail';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';
import { SortingMode } from 'shared/types/sorting-mode';
import { getSortedTasks } from 'shared/utils/get-sorted-tasks';
import { getWeekStartsOn } from 'shared/utils/get-week-starts-on';

import * as Styled from './tasks-list.style';

export const TasksList: React.FC = () => {
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);
  const today = useToday();
  const selectedTask = useActiveTaskId();

  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();
  const tasks = useInboxTodos();

  const { updateOrder } = useUpdateInboxTaskOrder();
  const openPremiumDialog = useOpenPremiumDialog();

  const sortedTasks = useMemo(
    () =>
      getSortedTasks(tasks, {
        today,
        order: user?.settings?.inboxSorting ?? [],
        mode: [SortingMode.Custom],
        weekStartsOn,
      }),
    [tasks, today, user?.settings?.inboxSorting, weekStartsOn],
  );

  return (
    <Styled.Container>
      <SelfSortingTaskSection
        tasks={sortedTasks}
        tagIds={user?.settings?.inboxFilterByTags}
        goals={goals}
        lifeAreas={lifeAreas}
        onReorder={updateOrder}
        selectedTask={selectedTask}
        onPremium={openPremiumDialog}
        canCreateTask
      />
    </Styled.Container>
  );
};
